import { Base, withMountWhenInView } from '@studiometa/js-toolkit';

/**
 * @typedef {{
 *  $refs: {
 *  btn: HTMLButtonElement,
 *  list: HTMLElement,
 * }
 * }} LocalSwitcherConfig
 */

/**
 * @extends Base<LocalSwitcherConfig>
 */
export default class LocalSwitcher extends withMountWhenInView(Base) {
  static config = {
    name: 'LocalSwitcher',
    log: true,
    refs: ['btn', 'list'],
  };

  isOpen = false;

  mounted() {
    this.$log('mounted');
  }

  toggle() {
    if (this.isOpen) {
      this.close();
      return;
    }

    this.open();
  }

  open() {
    this.$log('open')
    if (this.isOpen) {
      return;
    }

    this.isOpen = true;
    this.$refs.list.style.display = null;
  }

  close() {
    this.$log('close')
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;
    this.$refs.list.style.display = 'none';
  }

  onBtnClick() {
    this.toggle();
  }

  onWindowClick({ target }) {
    if (!this.isOpen || target === this.$refs.btn) {
      return;
    }

    this.close();
  }
}
